import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ContactFormModal from './ContactFormModal';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <button
          type="button"
          className="footer-link"
          onClick={() => setShowContactModal(true)}
        >
          {t('footer.contactUs')}
        </button>
        <Link className="footer-link" to="/help">
          {t('nav.help')}
        </Link>
        <Link className="footer-link" to="/information">
          {t('nav.information')}
        </Link>
        <Link className="footer-link" to="/gdpr">
          {t('footer.gdpr')}
        </Link>
        <Link className="footer-link" to="/general-terms">
          {t('footer.generalTerms')}
        </Link>
        <Link className="footer-link" to="/guidelines-reviews">
          {t('footer.guidelinesForReviews')}
        </Link>
      </div>
      <ContactFormModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </footer>
  );
};

export default Footer;
